//整数
export function intCheck(Location) {
  let regAddress = /^\d+$/
  return regAddress.test(Location);
}
//判断是否是地址
export function urlCheck(Location) {
  let regAddress = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/
  return regAddress.test(Location);
}
//身份证
export  function sfz(Location) {
  let idCard= /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
  return idCard.test(Location)
}
//手机号
export  function cellphonenumber(Location) {
  let idCard= /^1[0-9]{10}$/
  return idCard.test(Location)
}
//数字判断
export  function numb(Location) {
  let idCard=  /^\+?[1-9][0-9]*$/
  return idCard.test(Location)
}
//只能数字或小数 只能有一个小数点并且第一位不能为小数点
export function NumberCheck(num) {
  var re = /^\d*\.{0,1}\d{0,1}$/;
  return re.exec(num) != null;

}
//学校判断
export function schoolCheck(Location) {
  let reg = /(大学|学院|研究所)$/;
  return reg.test(Location)
}
//名次
export function rankCheck(Location) {
  let reg =  /^[1-9][0-9]*\/(0|[1-9][0-9]*)$/;
  return reg.test(Location)
}
//邮箱
export function emailCheck(Location) {
  let reg =  /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return reg.test(Location)
}
//输入表情
export function emojiCheck(Location) {
  let reg =  /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig;
  return reg.test(Location)
}
export function timeData(data) {
  var chinaStandard= data
  var date = new Date(chinaStandard);
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  m = m < 10 ? ('0' + m) : m;
  var d = date.getDate();
  d = d < 10 ? ('0' + d) : d;
  var h = date.getHours();
  var minute = date.getMinutes();
  minute = minute < 10 ? ('0' + minute) : minute;
  let time = y + '-' + m + '-' + d;
  return time
}
export function formatDate(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  };
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
    }
  }
  return fmt;
}

function padLeftZero(str) {
  return ('00' + str).substr(str.length);
}



// WEBPACK FOOTER //
// ./src/request/reg.js